module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_02_6NW26_1SC_HTW.6e439c7c.jpg";